<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10">
		<g id="Group_23895" data-name="Group 23895" transform="translate(-668.561 -378.413)">
			<g id="Rectangle_8017" data-name="Rectangle 8017">
				<rect
					id="Rectangle_8017-2"
					data-name="Rectangle 8017"
					width="11"
					height="10"
					rx="2"
					transform="translate(668.561 378.413)"
					fill="none"
				/>
				<path
					id="Path_20134"
					data-name="Path 20134"
					d="M670.561,378.913h7a1.5,1.5,0,0,1,1.5,1.5v6a1.5,1.5,0,0,1-1.5,1.5h-7a1.5,1.5,0,0,1-1.5-1.5v-6a1.5,1.5,0,0,1,1.5-1.5Z"
					fill="none"
					stroke="#939393"
					stroke-width="1"
				/>
			</g>
			<line
				id="Line_626"
				data-name="Line 626"
				y2="9"
				transform="translate(674.061 378.913)"
				fill="none"
				stroke="#939393"
				stroke-width="1"
			/>
			<g id="Group_23895-2" data-name="Group 23895">
				<line
					id="Line_627"
					data-name="Line 627"
					x2="10"
					transform="translate(669.061 381.914)"
					fill="none"
					stroke="#939393"
					stroke-width="1"
				/>
				<line
					id="Line_628"
					data-name="Line 628"
					x2="10"
					transform="translate(669.061 384.914)"
					fill="none"
					stroke="#939393"
					stroke-width="1"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'TableSvg',
};
</script>
